import Vue from "vue";
import VueRouter from "vue-router";
import Home from "@/views/home/index.vue";
import About from "@/views/about/index.vue";
import Privacy from "@/views/privacy/index.vue";
import Disclaimer from "@/views/disclaimer/index.vue";
import Explore from "@/views/explore/index.vue";
import Search from "@/views/search/index.vue";
import BookDetail from "@/views/book-detail/index.vue";
import ArticleDetail from "@/views/article-detail/index.vue";
import Authors from "@/views/authors/index.vue";
import AuthorDetail from "@/views/author-detail/index.vue";
import OpenAccess from "@/views/open-access/index.vue";

Vue.use(VueRouter);

const routes = [
  { path: "/", name: "Home", component: Home },
  { path: "/about", name: "About", component: About },
  { path: "/privacy", name: "Privacy", component: Privacy },
  { path: "/disclaimer", name: "Disclaimer", component: Disclaimer },
  { path: "/explore", name: "Explore", component: Explore },
  { path: "/search", name: "Search", component: Search },
  { path: "/book/:id", name: "BookDetail", component: BookDetail },
  { path: "/article/:id/:title", name: "ArticleDetail", component: ArticleDetail },
  { path: "/authors", name: "Authors", component: Authors },
  { path: "/author/:id", name: "AuthorDetail", component: AuthorDetail },
  { path: "/open-access", name: "OpenAccess", component: OpenAccess },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

export default router;
